import ContratTemplate from '@/generated/classes/ContratTemplate';
import { ArticleTemplate as ArticleTemplateBase } from '@/generated/classes/ContratTemplate';
export default class ContratTemplateExtend extends ContratTemplate {
  constructor() {
    super();
  }
}
export class ArticleTemplate extends ArticleTemplateBase {
  constructor() {
    super();
  }
}
